module.exports = __webpack_public_path__ + "img/basket.4dce27e8.svg";